/*
 * @Description: 
 * @Author: ywj
 * @Date: 2021-12-16 19:37:18
 */
import {useState, useEffect, useCallback} from 'react';
import {message} from 'antd';
import cookie from 'react-cookies';
// import url from 'url';
import {assetsUrl} from './assetsUrl';

const policyPDF = `${assetsUrl}assets/files/pdf/%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf`;
const policyPDFEn = `${assetsUrl}assets/files/pdf/PrivacyPolicy.pdf`;
const uistPDFEn = `${assetsUrl}assets/files/pdf/UserInformationServiceTerms.pdf`;
const uistPDF = `${assetsUrl}assets/files/pdf/用户信息服务条款.pdf`;

const isEnUS = cookie.load('lang') === 'en-US';

export function getDatetime(text, mon = 1) {
  const timestamp = text;
  const date = new Date(timestamp);
  let year = date.getFullYear();
  if (mon <= 1) {
    mon = 1;
  }
  let month = date.getMonth() + mon;
  let day = date.getDate();
  let hours = date.getHours();
  let minutes = date.getMinutes();
  if (month > 12) {
    month = date.getMonth() + mon - 12;
    year = year + 1;
  }
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }
  if (hours < 10) {
    hours = `0${hours}`;
  }
  if (minutes < 10) {
    minutes = `0${minutes}`;
  }
  const formattedDatetime = `${year}-${month}-${day} ${hours}:${minutes}`;
  return formattedDatetime;
}

// 邮箱验证
export const RegEmail = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/

/*
 * @author: zhangning
 * @date: 2021/6/28 17:24
 * @Description: 监听浏览器窗口大小改变事件，返回窗口大小信息
 **/
export function useWinSize() {
  const [size, setSize] = useState({
    width: document.documentElement.clientWidth,
    height: document.documentElement.clientHeight
  });

  const onResize = useCallback(() => {
    setSize({
      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [size.width]);

  useEffect(() => {
    window.addEventListener('resize', onResize);
    // return 表示只有销毁的时候才执行
    return () => {
      window.removeEventListener('resize', onResize);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return size;
}

/*
 * @author: zhangning
 * @date: 2021/7/1 14:48
 * @Description: 修改所有state中数据的方法
 **/
export function setMyState(setState, changeState) {
  setState((prevState) => {
    return {...prevState, ...changeState};
  });
}

/*
 * @author: zhangning
 * @date: 2021/10/28 10:30
 * @Description: 判断浏览器地址栏是否存在?en_us，设置为英文
 **/
export function setLangEnus() {
  console.log('setLangEnus');
  const urlParams = getUrlParamObj();
  if (!urlParams.lang) {
    return;
  }
  const lang = urlParams.lang.toLowerCase();
  const langObj = {
    'en-us': 'en-US',
    'zh-cn': 'zh-CN'
  };
  if (langObj[lang]) {
    handleChangeLanguage(langObj[lang]);
    delete urlParams.lang;
    const searchVal = spliceUrlParam(urlParams);
    // window.history.pushState({}, '', window.location.origin + window.location.pathname + searchVal + window.location.hash);
    window.location.href = window.location.origin + window.location.pathname + searchVal + window.location.hash;
  }

}


/**
 * 获取url中指定参数的值
 * @param {string} name
 * @returns  string 参数的值
 */
export const getUrlParam = function (name) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) === name) {
      return decodeURIComponent(pair[1]);
    }
  }
  return false;
};

/**
 * 获取url中参数的值，并返回对象
 * @returns obj 参数的值
 * 注意参数中如果有中文等编码参数需要解码
 */
export const getUrlParamObj = function () {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  const obj = {};
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    obj[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
  }
  return obj;
};

/**
 * 拼接url参数
 * @param {*} name
 * @param {*} value
 * @returns
 */
export const spliceUrlParam = (parmasObj) => {
  const nameArr = Object.keys(parmasObj).filter(Boolean);
  if (nameArr.length < 1) {
    return '';
  }
  return nameArr.reduce((str, key, index) => {
    const item = index === nameArr.length - 1 ? `${key}=${parmasObj[key]}` : `${key}=${parmasObj[key]}&`;
    return str + item;
  }, '?');
};

/*
* @author:YJ
* @date: 2022/1/6 10:20
* @result: object || Array
**/
export function deepCopy(obj) {
  const result = Array.isArray(obj) ? [] : {};
  for (const key in obj) { // 可以循环对象和数组
    if (obj.hasOwnProperty(key)) { // 可以判断对象（key）和数组（index）
      if (typeof obj[key] === 'object' && obj[key] !== null) { // typeof 对象 | 数组 | null ，返回 'object'
        result[key] = deepCopy(obj[key]);   //递归复制
      } else {
        result[key] = obj[key];
      }
    }
  }
  return result;
}

//转二进制
export function binaryChange(data) {
  //转二进制
  const arr = [];
  for (let i = 0; i < data; i++) {
    arr[i] = parseInt(i).toString(2);
  }
  for (let j = 0; j < arr.length; j++) {
    const l = arr[j].length; //获取要格式化数字的长度，如二进制1的话长度为1
    if (l < arr[data - 1].length) {
      //补全位数
      for (let jj = 0; jj < arr[data - 1].length - l; jj++) {
        arr[j] = '0' + arr[j]; //不够的就在前面补0
      }
    }
  }
  return arr;
}

//sort数字排序，从大到小排序
export function sortNumber(a, b) {
  return a - b;
}

/*删除数组中的某一个对象
_arr:数组
_obj:需删除的对象
*/
export function removeAaary(_arr, _obj) {
  const length = _arr.length;
  for (let i = 0; i < length; i++) {
    if (_arr[i] === _obj) {
      if (i === 0) {
        _arr.shift(); //删除并返回数组的第一个元素
        return _arr;
      } else if (i === length - 1) {
        _arr.pop();  //删除并返回数组的最后一个元素
        return _arr;
      }
      _arr.splice(i, 1); //删除下标为i的元素
      return _arr;

    }
  }
}

//界面提示弹层
export function prompt(msg, type) {
  if (type === 'success') {
    message.destroy();
    message.success(msg, 1);
  } else {
    message.destroy();
    message.warning(msg, 1);
  }
}

//验证参数设置的输入格式
export function expressionRegexp(expression) {
  const regexp = /^-*(\d+(\.\d+)?)(([+*-](\d+(\.\d*)?))|(\/([1-9]\d*(\.\d+)?|\d+\.[0-9]*[1-9][0-9]*))|(\^)(\d+))*$/;
  const regxpPi = /^-*((pi|PI)|\d+(\.\d+)?)(([+*-]((pi|PI)|\d+(\.\d*)?))|(\/((pi|PI)|[1-9]\d*(\.\d+)?|\d+\.[0-9]*[1-9][0-9]*))|(\^)(\d+|(pi|PI)))*$/;
  if (regxpPi.exec(expression)) {
    return regxpPi.exec(expression);
  }
  return regexp.exec(expression);
}


export function getTranslate(node, sty) {//获取transform值
  const translates = document.defaultView.getComputedStyle(node, null).transform.substring(7);
  const result = translates.match(/\(([^)]*)\)/);// 正则()内容
  const matrix = result ? result[1].split(',') : translates.split(',');
  if (sty === 'x' || typeof sty === 'undefined') {
    return matrix.length > 6 ? parseFloat(matrix[12]) : parseFloat(matrix[4]);
  } else if (sty === 'y') {
    return matrix.length > 6 ? parseFloat(matrix[13]) : parseFloat(matrix[5]);
  } else if (sty === 'z') {
    return matrix.length > 6 ? parseFloat(matrix[14]) : 0;
  }
}

export function getClientHeight() {
  let clientHeight = 0;
  if (document.body.clientHeight && document.documentElement.clientHeight) {
    clientHeight = document.body.clientHeight < document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
  } else {
    clientHeight = document.body.clientHeight > document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight;
  }
  return clientHeight;
}

//获取界面window的宽高
export function getViewportOffset() {
  if (window.innerWidth) {
    return {
      w: window.innerWidth,
      h: window.innerHeight
    };
  }
  if (document.compatMode === 'BackCompat') {
    return {
      w: document.body.clientWidth,
      h: document.body.clientHeight
    };
  }
  return {
    w: document.documentElement.clientWidth,
    h: document.documentElement.clientHeight
  };


}

//图形转代码，并在编程窗口输出
export function transNumber(e) {
  let expression = null;
  // eslint-disable-next-line no-eval
  expression = eval(e.replace(/pi/g, Math.PI.toFixed(6)).replace(/PI/g, Math.PI.toFixed(6))).toFixed(6);
  if (isNaN(expression)) {
    expression = 0;
  }
  return expression;
}

export function lookReadAgreement(type) {
  if (type === 1) {
    window.open(isEnUS ? uistPDFEn : uistPDF);
  } else {
    window.open(isEnUS ? policyPDFEn : policyPDF);
  }
}

export function handleChangeLanguage() {
  // 判断是否在测试环境或者是线上环境
  if (window.location.href.includes('.originqc.com')) {
    if (window.location.href.includes('.originqc.com.cn')) {
      // 线上环境
      // cookie.save('lang', value, {path: '/', domain: '.originqc.com.cn'});
    } else {
      // 测试环境
      // cookie.save('lang', value, {path: '/', domain: '.originqc.com'});
    }
  } else {
    // 本地环境
    // cookie.save('lang', value, { path: '/' });
  }
}

// 获取浏览器地址栏参数
export function getRequestParams(param) {
  const reg = new RegExp('(^|&)' + param + '=([^&]*)(&|$)', 'i');
  const r = window.location.search.substr(1).match(reg);
  return r !== null ? unescape(r[2]) : null;
}

// 节流函数
let timeout = null;
export const throttlFun = (fn, wait = 2000,...args) => {
  if (timeout) {
    return;
  }
  timeout = setTimeout(() => {
    if(args) {
      fn(...args);
    }
    clearTimeout(timeout);
    timeout = null;
  }, wait);
  fn();
};


/**
 * 节流
 * @param {*} fn
 * @returns
 */
export const throttle = (fn, delay) => {
  let canRun = true;
  return function () {
    if (!canRun) {
      return;
    }
    canRun = false;
    setTimeout(() => {
      fn.apply(this, arguments);
      canRun = true;
    }, delay || 16.7);
  };
};

/**
 * 判断属性在对象里而不是在原型上
 * @param obj
 * @param key
 * @returns {boolean}
 */
export const hasPropers = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

/**
 * @name:添加域名是否是originqc.com
 * @param {*} key lang/originqsid
 * @param {*} val  zh-CN、en-US/
 * @return {*}
 */
export const getIsDomain = function () {
  if (window.location.href.includes('.originqc.com')) {
    if (window.location.href.includes('.originqc.com.cn')) {
      // cookie.save(key, val, { path: '/', domain: '.originqc.com.cn' });
    } else {
      // cookie.save(key, val, { path: '/', domain: '.originqc.com' });
    }
  } else {
    // cookie.save(key, val, { path: '/' });
  }
};
// export const handleClearCookie = function () {
//   if (url.parse(window.location.search, true).query.sc_v1 === 'v1' && typeof url.parse(window.location.search, true).query.sc_v1Token === 'undefined') {
//     // cookie.remove('originqsid',{path:'/'});
//   }
// };

export function goLogin() {
  let forward = '';
  // if (str) {
  //   // 判断是否是第三方链接
  //   if (thirdHref) {
  //     forward = str;
  //   } else {
  //     forward = window.location.origin + str;
  //   }
  // } else {
    forward = window.location.href;
  // }
  // const forward = window.location.href;
  const lang = isEnUS ? 'en' : 'zh';
  if (window.location.href.includes('.originqc.com.cn')) {
    // 线上环境
    window.location.href =
      `https://auth.originqc.com.cn/${lang}/l/login?forward=${forward}`;
  } else if (window.location.href.includes('originqc.com')) {
    // 测试环境
    window.location.href =
      `https://auth.originqc.com/${lang}/l/login?forward=${forward}`;
  } else {
    const {origin} = window.location;
    window.location.href = `${origin}/${lang}/l/login?forward=${forward}`;
  }
}
export function goRegister() {
  let forward = '';

    forward = window.location.href;
  const lang = isEnUS ? 'en' : 'zh';
  if (window.location.href.includes('.originqc.com.cn')) {
    // 线上环境
    window.location.href =
      `https://auth.originqc.com.cn/${lang}/l/register?forward=${forward}`;
  } else if (window.location.href.includes('originqc.com')) {
    // 测试环境
    window.location.href =
      `https://auth.originqc.com/${lang}/l/register?forward=${forward}`;
  } else {
    const {origin} = window.location;
    window.location.href = `${origin}/${lang}/l/register?forward=${forward}`;
  }
}

export const downLoadXlsx = ({fileName, data}) => {
  // 生成一个改文件对象的url地址
  const fileURI = URL.createObjectURL(data);
  // 创建一个a链接标签
  const a = document.createElement('a');
  // 将文件对象的url地址赋值给a标签的href属性
  a.href = fileURI;
  // 为a标签添加download属性并指定文件的名称
  a.download = fileName;
  // 将a标签挂载到页面
  document.body.appendChild(a);
  // 调用a标签的点击函数
  a.click();
  // 释放URL对象
  URL.revokeObjectURL(fileURI);
  // 将页面的a标签删除
  document.body.removeChild(a);
};

export const windowOpenUrl = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = '_blank';
  link.style.display = 'none';
  link.textContent = '打开新窗口';
  document.body.appendChild(link);
  // 调用a标签的点击函数
  link.click();
  link.remove();
};


export const getlinkString = (linkString) => { 
  // console.log(linkString, typeof linkString,'linkString')
  if (linkString) { 
    try {
       // 将中文引号替换为英文引号
      // const sanitizedLinkString = linkString.replace(/[“”]/g, '"');
      const linkStringArr = JSON.parse(linkString);
      // const resultString = linkStringArr.join(' | ');

      return linkStringArr;
    } catch (error) {
      console.error('解析 JSON 字符串时出错:', error);
      return null;
    }
  }
  return null;
}

export const openCustomerService = () => {
  const url = 'https://work.weixin.qq.com/kfid/kfc97e7173a27d4c1ad';
  windowOpenUrl(url);
};

export const useCountdown = (initialTime) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  let interval = null;
  useEffect(() => {
        if (timeLeft > 0) {
          interval = setInterval(() => {
              setTimeLeft((prevTime) => prevTime - 1);
          }, 1000);
      } 
      // else if ( timeLeft !== initialTime) {
      //     setTimeLeft(initialTime);
      // }
      else {
        clearInterval(interval);
      }

      return () => clearInterval(interval);
  }, [timeLeft,initialTime]);

  const reset = (newTime) => {
    if (newTime !== undefined && newTime >= 0) {
      setTimeLeft(newTime); // Set the new time if provided
    } else {
      setTimeLeft(initialTime); // Reset to initialTime otherwise
    }
  };

  return { timeLeft, reset };
};

export const  timeToSeconds=(timeStr)=>{
  // 分割时间字符串，分别获取小时、分钟和秒
  if (timeStr) { 
    const [hours, minutes, seconds] = timeStr?.split(':').map(Number);
  // 计算总秒数
  return hours * 3600 + minutes * 60 + seconds;
  } 
  
}

export function secondsToTime(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  const pad = (num) => num.toString().padStart(2, '0');

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
}

// 订单购买
  // 获取购买方式
    export const getBuyWay = (type) => {
      switch (type) { 
        case '0':
          return '永久授权';
        case '1':
          return '按日购买';
        case '2':
          return '按周购买';
        case '3':
          return '按月购买';
        case '4':
          return '按季购买';
        case '5':
          return '按年购买';
        case '10':
          return '按次购买';
        break;   
      }
    }

export const getBuyNumber = (type, quality) => {
      console.log(type, quality,'quality')
      switch (type) { 
        case '0':
          return '永久授权';
        case '3':
          return `${quality}个月`;
        case '5':
          return `${quality}年`;

      }
    }